module.exports = __webpack_public_path__ + "img/list-active.8dddcc3e.svg";